<!-- HorizontalSlider.vue -->
<template>
	<input
		v-model="localScrollValue"
		type="range"
		:min="0"
		:max="scrollMax"
		@input="onSliderInput"
		class="slider pointer mb-3"
		id=""
	/>
</template>

<script>
export default {
	props: {
		scrollContainerRef: {
			type: HTMLElement, // Updated to expect HTMLElement
			required: true,
		},
		scrollContainerId: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			localScrollValue: 0,
			scrollMax: 100,
		};
	},
	created() {
		console.log("my idddd", this.scrollContainerId);

		this.calculateScrollMax();
	},
	mounted() {
		if (this.scrollContainerRef) {
			this.scrollContainerRef.addEventListener(
				"scroll",
				this.updateSliderOnScroll
			);
		}
	},
	beforeDestroy() {
		if (this.scrollContainerRef) {
			this.scrollContainerRef.removeEventListener(
				"scroll",
				this.updateSliderOnScroll
			);
		}
	},
	updated() {
	this.$nextTick(() => {
		this.calculateScrollMax();
	});
	},
	methods: {
		calculateScrollMax() {
			if (this.scrollContainerRef) {
				const scrollWidth = this.scrollContainerRef.scrollWidth;
				const clientWidth = this.scrollContainerRef.clientWidth;
				this.scrollMax = scrollWidth - clientWidth;
			}
		},
		onSliderInput() {
			if (this.scrollContainerRef) {
				const el = document.getElementById(this.scrollContainerId);
				if (el) {
					el.scrollLeft = this.localScrollValue;
				}
			}
			this.$emit("input", this.localScrollValue);
		},
		updateSliderOnScroll() {
			if (this.scrollContainerRef) {
				this.localScrollValue = this.scrollContainerRef.scrollLeft;
			}
		},
	},
	watch: {
		// Recalculate max scroll if scroll container changes
		scrollContainerRef(newVal) {
			if (newVal) {
				this.calculateScrollMax();
			}
		},
	},
};
</script>

<style>
</style>
